export default __webpack_public_path__ + "static/media/Spotlight.b182d5a9.svg";